var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.loading)?_c('teacher-form',{attrs:{"back-btn":false},on:{"save":_vm.save},model:{value:(_vm.entity),callback:function ($$v) {_vm.entity=$$v},expression:"entity"}}):_vm._e(),(_vm.loading)?_c('loading-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }